import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

export interface Props {
  src?: string | null;
  clickable?: boolean;
  scalable?: boolean;
  className?: string;
}

const ImageScreen = ({ src, clickable = false, scalable = false, className }: ClassAttributes<HTMLElement> & Props) => {
  return clickable && src != null ? (
    <AnchorLink href={src} target="_blank" className={className}>
      <Img src={src} />
    </AnchorLink>
  ) : scalable ? (
    <ScalebleImg src={src} className={className} />
  ) : (
    <Img src={src} className={className} />
  );
};

const AnchorLink = styled('a')({
  display: 'flex',
  alignItems: 'center',
});

const imgTemplete = {
  background: '#000',
  objectFit: 'contain',
  maxWidth: '100%',
  maxHeight: '100%',
};
const Img = styled('img')(imgTemplete as any) as any;

const ScalebleImg = styled('img')(
  // @ts-expect-error
  Object.assign(
    {
      cursor: 'pointer',
      transition: 'transform 0.2s ease-out',
      '&:hover': {
        transform: 'scale(1.5)',
      },
    },
    imgTemplete,
  ),
) as any;

export default ImageScreen;
